import { defineStore } from "pinia"
import axios from "axios"
import { useToast } from "@/components/ui/toast"
import i18n from '@/locales/i18n'

type EntityType = string

const { toast } = useToast()

export const useEntityStore = defineStore("entities", {
  state: () => ({
    entities: {} as Record<EntityType, any[]>,
    currentItem: {} as Record<EntityType, any | null>,
    showEditor: {} as Record<EntityType, boolean>,
  }),
  actions: {
    setItems(entity: EntityType, items: any[]) {
      this.entities[entity] = items
    },
    openEditor(entity: EntityType, item: any) {
	  console.log("openEditor=" + entity + " " + JSON.stringify(item))
      this.currentItem[entity] = { ...item } // clone to avoid mutating original
      this.showEditor[entity] = true
    },
    closeEditor(entity: EntityType) {
      this.currentItem[entity] = null
      this.showEditor[entity] = false
    },
	async saveEditor(entity: EntityType, saveEntity: EntityType, postAction: () => void, filter?: (key: string, value: any) => boolean ) {
	  const item = this.currentItem[entity];
	  console.log("saveEditor item=" + JSON.stringify(item))
	  if (!item) return;

	  try {
	    const token = document
	      .querySelector('meta[name="csrf-token"]')
	      ?.getAttribute("content");
	    if (token) axios.defaults.headers.common["X-CSRF-Token"] = token;
	    
	    // Add locale header for saving translations
	    const currentLocale = i18n.global.locale.value || 'de'
	    axios.defaults.headers.common['X-Locale'] = currentLocale

		let formEntity = saveEntity;
		if (entity.endsWith('s')) {
			formEntity = formEntity.slice(0, -1)
		}
	    const formData = new FormData();
	    for (const [key, value] of Object.entries(item)) {
		  console.log("useEntityStore key=" + key + " value=" + value)
		  if (filter && !filter(key, value)) {
			continue;
		  }
	      if (value instanceof File) {
	        // Handle file fields
	        formData.append(`${formEntity}[${key}]`, value, value.name);
	      } else if (value !== null && value !== undefined) {
	        formData.append(`${formEntity}[${key}]`, String(value));
	      }
	    }


		if (item.id) {
			await axios.patch(`${saveEntity}/${item.id}`, formData, {
			  headers: { "Content-Type": "multipart/form-data" },
			});			
		} else {
			await axios.post(`${saveEntity}`, formData, {
			  headers: { "Content-Type": "multipart/form-data" },
			});
		}

	    toast({
	      title: "Saved",
	      description: "Speichern erfolgreich.",
	    });

	    postAction();
	    this.closeEditor(entity);
	  } catch (error: any) {
		console.log("error=" + error)
	    const message =
	      error.response?.data?.message ||
	      error.response?.statusText ||
		  error.message ||
	      "Failed to save row.";

	    toast({
	      title: "Error",
	      description: message,
	      variant: "destructive",
	    });
	  }
	},
    updateField(entity: EntityType, key: string, value: any) {
      if (this.currentItem[entity]) {
        this.currentItem[entity][key] = value
      }
    },
  },
})
